module.exports = __webpack_public_path__ + "static/SectionThreeResponsive-bf4fbb6819fae93f389d47fc318a7b6b.png";